let captchaLoaded = false
let createCaptchaToken
let createCaptchaTokenWrapper
let pendingCaptchaInit = true
let captchaInitResolver
let captchaInitPromise = new Promise(resolver => {
  captchaInitResolver = resolver
})
let currentToken
let ts = { token: undefined, widget: undefined }

const setupCaptcha = (captchaType, captchaId, turnStileSiteKey, captchaVisibility) => {
  if (createCaptchaTokenWrapper) return createCaptchaTokenWrapper
  if (captchaType === 'google' && !captchaId) return console.warn('Google CaptchaID is missing')
  if (captchaType === 'turnstile' && !turnStileSiteKey)
    return console.warn('TurnStile site key is missing')

  // add dynamic script tag
  let script = document.createElement('script')
  document.getElementsByTagName('head')[0].appendChild(script)

  switch (captchaType) {
    case 'turnstile':
      script.setAttribute('src', `https://challenges.cloudflare.com/turnstile/v0/api.js`)
      script.onload = () => {
        // console.log(captchaType, 'here')
        ts.widget = turnstile.render(document.body, {
          sitekey: turnStileSiteKey,
          theme: 'light',
          callback: token => {
            // console.log('token', token)
            ts.token = token
          },
          errorCallback: e => {
            console.error('error with turnstile', e)
          },
          expiredCallback: () => {
            turnstile.reset()
          },
          appearance: 'execute',
        })

        createCaptchaToken = async action => {
          ts.token = undefined

          turnstile.reset()
          const maxWaitTime = 10000
          const startTime = Date.now()

          while (!ts.token) {
            // Check if we've exceeded the maximum wait time
            if (Date.now() - startTime > maxWaitTime) {
              throw new Error('Timeout waiting for captcha token')
            }
            // console.log('awaiting captcha token...')
            await new Promise(resolve => setTimeout(resolve, 200))
          }

          return ts.token
        }

        pendingCaptchaInit = false
        captchaInitResolver()
      }
      break
    default:
      script.setAttribute('src', `https://www.google.com/recaptcha/api.js?render=${captchaId}`)

      script.onload = () => {
        window.grecaptcha.ready(async () => {
          hideCaptchaBadge(captchaVisibility)
          createCaptchaToken = async action => window.grecaptcha.execute(captchaId, { action })
          pendingCaptchaInit = false
          captchaInitResolver()
        })
      }
  }

  if (!createCaptchaTokenWrapper) {
    createCaptchaTokenWrapper = async action => {
      if (pendingCaptchaInit) await captchaInitPromise
      return createCaptchaToken(action)
    }
  }

  return createCaptchaTokenWrapper
}

const hideCaptchaBadge = visibility => {
  if (visibility) {
    const badge$ = document.querySelector('.grecaptcha-badge')
    if (badge$) badge$.style.visibility = 'hidden'
  }
}

export default setupCaptcha
